import React, { useState, useEffect, useContext,useRef } from 'react';
import PropTypes from 'prop-types';
import { dropdownSpacingMultiplier } from '../../util/ProductModalHelpers';
import SizeSelectorItem from './SizeSelectorItem.jsx';
import './SizeSelector.css';
import I18NextContext from '../../../../../../ui/i18next-context/I18NextContext'
import { isMobileDevice } from '../../../../../../../utils/DeviceDetector';
import { withTranslation } from 'react-i18next';
import { ProductModalContext } from '../../../ProductModalContext';

const isMobile = isMobileDevice();

const SizeSelector = ({ groupProducts, sku, fontStyle, variantSize, setVariantSize, colors, variantColor, productVariantMap, setVariantColor, setSelectedVariantSKU, t }) => {
    const [sizes, setSizes] = useState(null);
    const { currentLanguage } = useContext(I18NextContext);
    const [leftArrowVisible, setLeftArrowVisible] = useState(false);
    const [rightArrowVisible, setRightArrowVisible] = useState(false);
    const [isUserScrolling, setIsUserScrolling] = useState(false);
    const scrollRef = useRef();
    const intervalRef = useRef();
    const {setShowSizeGuide } = useContext(ProductModalContext);

    useEffect(() => {
        if((Object.keys(productVariantMap.features_map).length > 0)){
            const defaultColor = Object.keys(productVariantMap.features_map)[0]
            setVariantColor(defaultColor);
        }
        return () => { setSelectedVariantSKU(sku) };
    }, [])

    useEffect(() => {
        let sizeArray = null;
        if((Object.keys(productVariantMap.features_map).length > 0)){
            if(typeof productVariantMap.features_map[variantColor] != "undefined"){
                sizeArray = variantColor && Object.keys(productVariantMap.features_map[variantColor])
            }else{
                const color = Object.keys(productVariantMap.features_map)[0]
                sizeArray = Object.keys(productVariantMap.features_map[color])
            }
            setSizes(sizeArray);
            setRightArrowVisible(sizeArray.length > 5)
            // reset size to null when the user chooses another color
            setVariantSize(sizeArray[0]);
        }else{
            setSizes(null);
        }
    }, [variantColor, sku, productVariantMap])


    const handleOnClick = (size) => {
        setVariantSize(size)
    }

    const handleScroll = (e) => {
        if (sizes.length <= 5) {
            return;
        }

        const scrollbar = scrollRef.current;
        const scrollLeft = scrollbar.scrollLeft;
        const scrollWidth = scrollbar.scrollWidth - scrollbar.clientWidth;
        const percentage = (scrollLeft / scrollWidth) * 100;

        if (percentage <= 0) {
            setLeftArrowVisible(false);
        } else if (percentage >= 90) {
            setRightArrowVisible(false);
        } else {
            // Seems redundant but will prevent event handler from constantly setting arrows to visible
            if (!leftArrowVisible) {
                setLeftArrowVisible(true);
            }
            if (!rightArrowVisible) {
                setRightArrowVisible(true);
            }
        }
    }

    const scrollStart = (e, direction) => {
        e.preventDefault();

        if (!isUserScrolling) {
            setIsUserScrolling(true);
            const scrollbar = scrollRef.current;
            const scrollWidth = scrollbar.scrollWidth - scrollbar.clientWidth;
            const scrollStep = isMobile ? 10 : 16;
            const scrollTimer = 20;
            setSideScroll(true, scrollbar, direction, scrollStep, scrollWidth, scrollTimer);
        }
    }

    const scrollEnd = (e) => {
        setTimeout(() => setSideScroll(false), 200);
    }

    const setSideScroll = (intervalStart, ref, direction, step, width, timer) => {
        if (intervalStart) {

            intervalRef.current = setInterval(() => {
                if (direction === 'right') {
                    ref.scrollLeft += step;
                } else {
                    ref.scrollLeft -= step;
                }

                if (ref.scrollLeft >= width) {
                    setIsUserScrolling(false);
                    clearInterval(intervalRef.current)
                } else if (ref.scrollLeft <= 0) {
                    setIsUserScrolling(false);
                    clearInterval(intervalRef.current)
                }
            }, timer);
        } else {
            setIsUserScrolling(false);
            clearInterval(intervalRef.current);
        }
    }

    return (
        (sizes && <div id="size-selector-column" className="flex-center" style={{ ...fontStyle }}>
            <div className="size-text">{t('selectASize')}</div>
            <div onClick={() => setShowSizeGuide(true)} className="size-guide-text">{t('sizeGuide')}</div>
            <div id="size-selector-items" className="flex-center" ref={scrollRef} onScroll={handleScroll} >
                {sizes && sizes.map((size, index) => (
                    <SizeSelectorItem
                        key={index}
                        relative={true}
                        onClick={() => handleOnClick(size)}
                        text={size}
                        selected={variantSize}
                    />
                ))}
            </div>
            <div className="size-selector-nav">
                <span className="size-selector-prev"
                    style={{ visibility: leftArrowVisible ? 'visible' : 'hidden' }}
                    onMouseDown={(e) => { scrollStart(e, 'left') }}
                    onMouseUp={scrollEnd}
                    onTouchStart={(e) => { scrollStart(e, 'left') }}
                    onTouchEnd={scrollEnd}
                ></span>
                <span className="size-selector-next"
                    style={{ visibility: rightArrowVisible ? 'visible' : 'hidden' }}
                    onMouseDown={(e) => { scrollStart(e, 'right') }}
                    onMouseUp={scrollEnd}
                    onTouchStart={(e) => { scrollStart(e, 'right') }}
                    onTouchEnd={scrollEnd}
                ></span>
            </div>
        </div>)
    );
}

SizeSelector.propTypes = {
    groupProducts: PropTypes.array.isRequired,
    fontStyle: PropTypes.object,
    size: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    fetchProductInfo: PropTypes.func.isRequired
};

export default withTranslation()(SizeSelector);
